import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect";
import { flash_alert } from 'components/App';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialTable from 'react-data-table-component';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@material-ui/core/Box';
import {useTranslation} from "react-i18next"
import i18next from 'i18next';

import {csrf, headers} from "constants/csrf"

function getSparePartColumns(customerProductId, onRefresh, isVisitCompleted) {
    const columns = [
        {
            name: i18next.t('globalTables.sparePartColumns.tnr'),
            selector: 'service_spare_part.spare_part.tnr',
            sortable: true,
            hide: 'sm',
        },
        {
            name: i18next.t('globalTables.sparePartColumns.name'),
            selector: 'service_spare_part.spare_part.name',
            sortable: true,
        },
        {
            name: i18next.t('globalTables.sparePartColumns.quantity'),
            selector: row => row.quantity,
            sortable: true,
        },
    ];

    if (!isVisitCompleted) {
        columns.push({
            name: i18next.t('globalTables.sparePartColumns.actions'),
            cell: row => (
                <span>
                    <EditSparePartDialog row={row} customerProductId={customerProductId} onSuccess={onRefresh} />
                    <DeleteSparePartDialog row={row} customerProductId={customerProductId} onSuccess={onRefresh} />
                </span>
            ),
        });
    }

    return columns;
}

const GET_USED_SPARE_PARTS_REQUEST = "GET_USED_SPARE_PARTS_REQUEST";
const GET_USED_SPARE_PARTS_SUCCESS = "GET_USED_SPARE_PARTS_SUCCESS";

function EditSparePartDialog({ row, customerProductId, onSuccess }) {
    const [open, setOpen] = useState(false);
    const [quantity, setQuantity] = useState(row.quantity);

    // Get spare part info - handle both data structures
    const sparePart = row.spare_part || row.service_spare_part?.spare_part;
    const sparePartName = sparePart?.name || 'N/A';
    const sparePartTnr = sparePart?.tnr || 'N/A';

    function handleClickOpen(e) {
        e.preventDefault();
        setOpen(true);
    }

    function handleClose(e) {
        e.preventDefault();
        setOpen(false);
    }

    function handleQuantity(e) {
        const value = parseInt(e.target.value);
        if (value < 1 || value > 99) {
            flash_alert("Error", "Debe ingresar una cantidad entre 1 y 99", "error");
        } else {
            setQuantity(value);
        }
    }

    async function handleEdit(e) {
        e.preventDefault();
        setOpen(false);

        const body = {
            quantity: quantity
        };

        console.log('=== EDITING USED SPARE PART ===');
        console.log('Row ID:', row.id);
        console.log('Customer Product ID:', customerProductId);
        console.log('Body:', body);
        console.log('================================');

        axios.patch(`/api/v1/customer_products/${customerProductId}/customer_product_used_spare_parts/${row.id}`, body, {
            headers: headers
        })
            .then(response => {
                console.log('Edit response:', response.data);
                flash_alert("", "Refacción actualizada correctamente", "success");
                onSuccess();
            })
            .catch(error => {
                console.error('Edit error:', error);
                console.error('Error response:', error.response);
                flash_alert("Error", "No se ha podido actualizar la refacción", "error");
            });
    }

    return (
        <React.Fragment>
            <Link href="#" className="mdl-navigation__link brand-primary-link sparepart-edit-link mg-r-15" onClick={handleClickOpen}>
                <i className="material-icons material-icons-20">edit</i> Editar
            </Link>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={handleClose}
            >
                <DialogTitle className="edit-sparepart-dialog-title">Editar refacción</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Grid container spacing={1}>
                            <Grid item xs={12} className="edit-sparepart-dialog-product-name">
                                {sparePartName} ({sparePartTnr})
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    InputProps={{ inputProps: { min: 1, max: 99 } }}
                                    label="Cantidad"
                                    name="quantity"
                                    value={quantity}
                                    onChange={handleQuantity}
                                />
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cerrar
                    </Button>
                    <Button onClick={handleEdit} variant="contained" color="primary" autoFocus>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function DeleteSparePartDialog({ row, customerProductId, onSuccess }) {
    const [open, setOpen] = useState(false);

    // Get spare part info - handle both data structures
    const sparePart = row.spare_part || row.service_spare_part?.spare_part;
    const sparePartName = sparePart?.name || 'N/A';
    const sparePartTnr = sparePart?.tnr || 'N/A';

    function handleClickOpen(e) {
        e.preventDefault();
        setOpen(true);
    }

    function handleClose(e) {
        e.preventDefault();
        setOpen(false);
    }

    async function handleDelete(e) {
        e.preventDefault();
        setOpen(false);

        console.log('=== DELETING USED SPARE PART ===');
        console.log('Row ID:', row.id);
        console.log('Customer Product ID:', customerProductId);
        console.log('=================================');

        axios.delete(`/api/v1/customer_products/${customerProductId}/customer_product_used_spare_parts/${row.id}`, {
            headers: headers
        })
            .then(response => {
                console.log('Delete response:', response.data);
                flash_alert("", "Producto eliminado correctamente", "success");
                onSuccess();
            })
            .catch(error => {
                console.error('Delete error:', error);
                console.error('Error response:', error.response);
                flash_alert("Error", "No se ha podido eliminar el producto", "error");
            });
    }

    return (
        <React.Fragment>
            <Link href="#" className="mdl-navigation__link brand-primary-link product-delete-link" onClick={handleClickOpen}>
                <i className="material-icons">delete</i> Eliminar
            </Link>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle className="delete-sparepart-dialog-title">¿Está seguro que desea eliminar el producto?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        ¿Está seguro que desea eliminar el producto {sparePartName} ({sparePartTnr})?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Sí
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

function getSpareParts(customer_product_id, visit_id, service_id, setUserLoading) {
    return dispatch => {
        dispatch({type: GET_USED_SPARE_PARTS_REQUEST});
        return fetch(`/api/v1/customer_products/${customer_product_id}/customer_product_used_spare_parts?visit_id=${visit_id}&service_id=${service_id}`)
        .then(response => {
            console.log('=== USED SPARE PARTS RESPONSE ===');
            console.log('Status:', response.status);
            console.log('OK:', response.ok);
            if (!response.ok) {
                console.error('Response not OK, status:', response.status);
            }
            return response.json();
        })
        .then(json => {
            console.log('=== USED SPARE PARTS DATA RECEIVED ===');
            console.log('Full response:', json);
            if (json && json.length > 0) {
                console.log('First item structure:', json[0]);
            }
            console.log('======================================');
            dispatch(getSparePartsSuccess(json));
            setUserLoading(false);
            return json;
        })
        .catch(error => {
            console.error('=== ERROR FETCHING USED SPARE PARTS ===');
            console.error('Error:', error);
            console.error('=======================================');
            setUserLoading(false);
        });
    };
};
export function getSparePartsSuccess(json) {
    return {
        type: GET_USED_SPARE_PARTS_SUCCESS,
        json
    };
};



function VisitUsedSpareParts(props){
    const {t} = useTranslation();
    const [checked, setChecked] = useState((props.visit.customer_products.length > 0 && props.visit.customer_products[0].id || ""));
    const [selectedCustomerProduct, setSelectedCustomerProduct] = useState((props.visit.customer_products && props.visit.customer_products[0] || {}));
    const [userLoading, setUserLoading] = useState(false);
    const [selectedCustomerProductSpareParts, setSelectedCustomerProductSpareParts] = useState([])

    const [requestedParts, setRequestedParts] = useState([]);
    const [selectedRequestedParts, setSelectedRequestedParts] = useState([]);
    const [isLoadingRequestedParts, setIsLoadingRequestedParts] = useState(false);
    const [selectedPrediagnosisParts, setSelectedPrediagnosisParts] = useState([]);

    const isServiceFinalizado = props.serviceStatusLabel === "Finalizado" || props.serviceStatusLabel === "Completado";
    const isVisitCompleted = props.visit.status === 'Visita completada';
    const canAddSpareParts = !isVisitCompleted && !isServiceFinalizado;

    const requested_parts_columns = [
        {
            name: 'TNR',
            selector: 'spare_part.tnr',
            sortable: true,
            hide: 'sm',
        },
        {
            name: 'Nombre',
            selector: 'spare_part.name',
            sortable: true,
        },
        {
            name: 'Cantidad Solicitada',
            selector: row => row.requested_quantity,
            sortable: true,
        }
    ];

    useEffect(() => {
        setUserLoading(true)
        if(selectedCustomerProduct && selectedCustomerProduct.id){
            props.getSpareParts(selectedCustomerProduct.id, props.visit.id, props.serviceID, setUserLoading);
            fetchRequestedParts(selectedCustomerProduct.id, props.visit.id);
        } else {
            setUserLoading(false)
        }
    }, [selectedCustomerProduct]);

    function handleToggle(customer_product){
        setChecked(customer_product.id)
        setSelectedCustomerProduct(customer_product)
    }

    function handleRefresh() {
        setUserLoading(true);
        props.getSpareParts(selectedCustomerProduct.id, props.visit.id, props.serviceID, setUserLoading);
    }

    function fetchRequestedParts(customerProductId, visitId) {
        setIsLoadingRequestedParts(true);
        fetch(`/api/v1/customer_products/${customerProductId}/customer_product_requested_spare_parts?visit_id=${visitId}`)
            .then(response => response.json())
            .then(json => {
                console.log('Requested parts for selection:', json);
                // Extract data array from response object
                const partsArray = json.data || json || [];
                console.log('Extracted parts array:', partsArray);
                setRequestedParts(partsArray);
                setIsLoadingRequestedParts(false);
            })
            .catch(error => {
                console.error('Error fetching requested parts:', error);
                setIsLoadingRequestedParts(false);
            });
    }

    function handleRequestedPartRowChange(state) {
        setSelectedRequestedParts(state.selectedRows);
    }

    function handlePrediagnosisPartRowChange(state) {
        setSelectedPrediagnosisParts(state.selectedRows);
    }

    async function assignSpareParts(selectedParts, setLoading) {
        if (!selectedCustomerProduct || !selectedCustomerProduct.id) {
            flash_alert("Error", "Debe seleccionar un producto del cliente", "error");
            return;
        }

        setLoading(true);

        try {
            const serviceId = selectedParts[0].service_id;
            const serviceSparePartIds = selectedParts.map(p => p.id);

            const body = {
                id: String(selectedCustomerProduct.id),
                service_id: String(serviceId),
                service_spare_part_ids: serviceSparePartIds.join(','),
                quantities: selectedParts.map(p => p.requested_quantity || p.quantity || 1).join(','),
                warranties: selectedParts.map(() => "false").join(','),
                customer_product_id: String(selectedCustomerProduct.id),
                technician_id: String(props.current_user.id),
                visit_id: String(props.visit.id)
            };

            await axios.post(`/api/v1/customer_products/${selectedCustomerProduct.id}/assign_spare_parts`, body, {
                headers: headers
            });

            flash_alert("", "Refacciones agregadas como utilizadas exitosamente", "success");
            props.getSpareParts(selectedCustomerProduct.id, props.visit.id, props.serviceID, setUserLoading);
            fetchRequestedParts(selectedCustomerProduct.id, props.visit.id);
            setLoading(false);
        } catch (error) {
            console.error('Error assigning spare parts:', error.response);
            flash_alert("Error", "Error al agregar refacciones utilizadas", "error");
            setLoading(false);
        }
    }

    async function handleAddUsedSpareParts() {
        if (selectedRequestedParts.length === 0) {
            flash_alert("Error", "Debe seleccionar al menos una refacción solicitada", "error");
            return;
        }
        await assignSpareParts(selectedRequestedParts, setIsLoadingRequestedParts);
        setSelectedRequestedParts([]);
    }

    async function handleAddPrediagnosisSpareParts() {
        if (selectedPrediagnosisParts.length === 0) {
            flash_alert("Error", "Debe seleccionar al menos una refacción de prediagnóstico", "error");
            return;
        }
        await assignSpareParts(selectedPrediagnosisParts, () => {});
        setSelectedPrediagnosisParts([]);
    }

	return (
		<React.Fragment>
                <p className="service-subtitle">{t('services.visits.productTableInfo.useSpareParts')}</p>
                <List>
                {props.visit.customer_products && props.visit.customer_products.map((customer_product) => {
                    const listId = `list-visit-products-${props.visit.id}-${customer_product.id}`;
                    const labelId = `visit-products-${props.visit.id}-${customer_product.id}`;

                    return (
                    <ListItem key={listId} role={undefined} dense button onClick={() => handleToggle(customer_product)}>
                        <ListItemIcon className="service-address-label">
                        <FormControlLabel value={customer_product.id} control={<Radio color="primary"/>} label="" checked={checked == customer_product.id}
                            tabIndex={-1}
                        />
                        </ListItemIcon>
                        <ListItemText 
                            id={labelId}
                            secondary={
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.name')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.name}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.tnr')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.tnr}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.id')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.serial_id}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <span className="visit-summary-1">{t('services.visits.productTableInfo.status')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.status}</span>
                                    </Grid>
                                </Grid>
                            } 
                        />
                        
                    
                        <ListItemSecondaryAction>
                        
                        </ListItemSecondaryAction>
                    </ListItem>
                    );
                })}
                
                </List>
                <Grid style={{marginTop: "15px"}} container spacing={1}>
                    <Grid item xs={12}>
                            <MaterialTable
                                noHeader={true}
                                columns={getSparePartColumns(selectedCustomerProduct.id, handleRefresh, isVisitCompleted || isServiceFinalizado)}
                                data={props.spare_parts}
                                progressPending={userLoading}
                                progressComponent={<CircularProgress size={75} />}
                                responsive={true}
                                highlightOnHover={true}
                                striped={true}
                                contextMessage={{ singular: 'producto', plural: 'productos', message: 'seleccionados' }}
                                noDataComponent={i18next.t('globalText.NoDataComponent')}
                                paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
                            />
                    </Grid>
                </Grid>

                {canAddSpareParts &&
                    <>
                        <Grid style={{marginTop: "30px"}} container spacing={1}>
                            <Grid item xs={12}>
                                <p className="service-subtitle">Agregar Refacciones Utilizadas desde Solicitadas</p>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
                                    <Box component="span" p={0} m={0} bgcolor="background.paper">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleAddUsedSpareParts}
                                            disabled={selectedRequestedParts.length === 0 || isLoadingRequestedParts}
                                        >
                                            Marcar como Utilizadas
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Box component="span" p={0} m={0} bgcolor="background.paper">
                                    <MaterialTable
                                        noHeader={true}
                                        columns={requested_parts_columns}
                                        data={requestedParts}
                                        progressPending={isLoadingRequestedParts}
                                        progressComponent={<CircularProgress size={75} />}
                                        responsive={true}
                                        onSelectedRowsChange={handleRequestedPartRowChange}
                                        highlightOnHover={true}
                                        striped={true}
                                        selectableRows
                                        selectableRowsComponent={Checkbox}
                                        selectableRowsComponentProps={{ className: "product-checkbox", color: "primary" }}
                                        contextMessage={{ singular: 'refacción', plural: 'refacciones', message: 'seleccionadas' }}
                                        noDataComponent="No hay refacciones solicitadas disponibles"
                                        paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid style={{marginTop: "30px"}} container spacing={1}>
                            <Grid item xs={12}>
                                <p className="service-subtitle">Agregar Refacciones Utilizadas desde Prediagnóstico</p>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
                                    <Box component="span" p={0} m={0} bgcolor="background.paper">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleAddPrediagnosisSpareParts}
                                            disabled={selectedPrediagnosisParts.length === 0}
                                        >
                                            Marcar como Utilizadas
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Box component="span" p={0} m={0} bgcolor="background.paper">
                                    <MaterialTable
                                        noHeader={true}
                                        columns={requested_parts_columns}
                                        data={props.service_spare_parts || []}
                                        progressPending={false}
                                        progressComponent={<CircularProgress size={75} />}
                                        responsive={true}
                                        onSelectedRowsChange={handlePrediagnosisPartRowChange}
                                        highlightOnHover={true}
                                        striped={true}
                                        selectableRows
                                        selectableRowsComponent={Checkbox}
                                        selectableRowsComponentProps={{ className: "product-checkbox", color: "primary" }}
                                        contextMessage={{ singular: 'refacción', plural: 'refacciones', message: 'seleccionadas' }}
                                        noDataComponent="No hay refacciones de prediagnóstico disponibles"
                                        paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                }
		</React.Fragment>
	);
  
}

const structuredSelector = createStructuredSelector({
    spare_parts: state => state.used_spare_parts,
    service_spare_parts: state => state.spare_parts,
    current_user: state => state.current_user,
});

const mapDispatchToProps = {getSpareParts};

export default connect(structuredSelector, mapDispatchToProps)(VisitUsedSpareParts)

